import * as React from 'react';
import _ from 'lodash';
import Panel from './Toolbox/Panel';

type Props = {
    tools: []
};
type ToolboxWrapperTypes = {
    children?: React.Node
};
const ToolboxWrapper = ({children}: ToolboxWrapperTypes) => (
    <div className="bg-gray-50 p-4  m-4 shadow w-1/1    rounded-lg   flex flex-1 justify-center   " rmthumb="1"
         style={{
             width: '200px', height: '575px'
         }}
    >{children}</div>
);
ToolboxWrapper.defaultProps = {
    children: null
};
export default function Toolbox({tools, minWidth, maxWidth, EditorProps, EditorPropsChange, Pages}: Props) {
    if (!tools) return <ToolboxWrapper/>;
    return (
        <ToolboxWrapper>
            {tools.map(tool => (
                <Panel
                    key={_.identity('tool')}
                    title={tool.title}
                    collapse
                    tools={tool.items}
                    description={tool.description}
                    minWidth={minWidth}
                    maxWidth={maxWidth}
                    EditorPropsChange={EditorPropsChange}
                    EditorProps={EditorProps}
                    Pages={Pages}
                />
            ))}
        </ToolboxWrapper>
    );
}
